import { Component, ViewChild } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  Platform
} from "ionic-angular";
import { RequestServiceProvider } from "../../providers/request-service/request-service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormGroupDirective
} from "@angular/forms";
import { TransactionAlertProvider } from "../../providers/transaction-alert/transaction-alert";
import { LoadingProvider } from "../../providers/loading/loading";
import { File } from "@ionic-native/file";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { CONFIG } from "../../config/config";
declare var cordova: any;

/**
 * Generated class for the OpenAccountPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-open-account",
  templateUrl: "open-account.html"
})
export class OpenAccountPage {
  @ViewChild("accountOpeningSilder") accountOpeningSilder: any;

  slideOneForm: FormGroup;
  slideTwoForm: FormGroup;
  slideThreeForm: FormGroup;
  states: Array<Object>;
  cities: Array<Object>;
  submitAttempt = false;
  picture: any;
  signImage: any;
  signPath: any;
  banks = [];
  showMajorBanker: boolean = false;
  card: boolean = false;
  validateAtmCost: boolean = false;
  bankImage: string = this.navParams.data.bank.cbn;
  bankName: string = this.navParams.data.bank.name;
  userInfo = {};
  step = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private request: RequestServiceProvider,
    private formBuilder: FormBuilder,
    private alert: TransactionAlertProvider,
    private loading: LoadingProvider,
    private platform: Platform,
    private camera: Camera
  ) {
    this.formValidations();
    
  }

  getLga(state) {
    console.log(state);
    this.cities = state.lga;
  }

  enquiry() {
    this.submitAttempt = true;

    if (this.slideOneForm.valid) {
      this.loading.presentLoading("Loading...");
      this.request
        .postAccountEnquiry({
          ...this.slideOneForm.value,
          bank_name: this.bankName
        })
        .subscribe(
          data => {
            this.loading.loader.dismiss().catch(() => {});
            const enquiry = JSON.parse(data.text());

            if (enquiry.ResponseCode === "00") {
              const {
                EnrolmentBank,
                MobileNumber,
                RegistrationDate,
                IsTimeout,
                ResponseCode,
                Description,
                Result,
                LoggerID,
                HasToken,
                ErroMsg,
                AdditionalData,
                ...userData
              } = enquiry.Data;

              this.userInfo = userData;
              this.next();
            } else if (enquiry.ResponseCode === "96") {
              this.alert.presentNormalErrorAlert("Incorrect BVN");
            }
          },
          error => {
            console.log(error.json());
            this.loading.loader.dismiss().catch(() => {});
            if (error.json().exception !== "Exception") {
              this.alert.presentNormalErrorAlert("An error occurred try again");
            } else {
              this.alert.presentNormalErrorAlert(
                error.json().message ||
                  "An error occurred, check your internet connection and try again."
              );
            }
          }
        );
    }
  }

  next() {
    this.accountOpeningSilder.slideNext();
    this.step++;
  }

  prev() {
    this.accountOpeningSilder.slidePrev();
    this.step--;
  }


  signScan() {
    const file = new File();
    const configuration = {
      source: "camera",
      jpegQuality: 20
    };
    cordova.plugins.GeniusScan.setLicenceKey(
      CONFIG.scannerKey,
      response => {
        console.log("initialized", response);
      },
      error => {
        console.log("initialized", error);
      }
    );
    cordova.plugins.GeniusScan.scanWithConfiguration(
      configuration,
      async result => {
        const [processed] = result.scans;
        const { enhancedUrl } = processed;
        const filename = enhancedUrl.substring(
          enhancedUrl.lastIndexOf("/") + 1
        );
        const path = enhancedUrl.substring(0, enhancedUrl.lastIndexOf("/") + 1);
        this.loading.presentLoading("uploading...");
        this.signPath = `${path}${filename}`;
        this.signImage = await file.readAsDataURL(path, filename);
        this.loading.loader.dismiss().catch(() => {});
      },
      error => {
        this.alert.presentNormalErrorAlert("Failed to upload, Try again");
      }
    );
  }

   pictureScan() {
  
    const options: CameraOptions = {
      quality: 30,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      cameraDirection: this.camera.Direction.FRONT,
      correctOrientation: true
    };

    this.camera.getPicture(options).then(
      imageData => {
        // imageData is either a base64 encoded string or a file URI
        // If it's base64 (DATA_URL):
        this.picture = "data:image/jpeg;base64," + imageData;

      },
      err => {
        // Handle error
      }
    );
  
  }
  
  createAccount() {
    this.submitAttempt = true;

    if (
      this.slideThreeForm.value.atm &&
      parseInt(this.slideThreeForm.value.depositAmt, 10) < this.navParams.data.bank.minimum_balance
    ) {
      this.validateAtmCost = true;
      return;
    }

    if (!this.slideOneForm.valid) {
      this.accountOpeningSilder.slideTo(0);
    } else if (!this.slideTwoForm.valid) {
      this.accountOpeningSilder.slideTo(1);
    } else if (!this.slideThreeForm.valid) {
      this.accountOpeningSilder.slideTo(2);
    } else {
      const formOne = this.slideOneForm.value;
      const formTwo = this.slideTwoForm.value;
      const formThree = this.slideThreeForm.value;
      const otherInfo = {
        signImage: this.signImage,
        agentCode: window.localStorage.getItem("agentCode"),
        bankName: this.bankName
      };
      const data = {
        ...this.userInfo,
        ...formOne,
        ...formTwo,
        ...formThree,
        ...otherInfo
      };
      this.navCtrl.push("ConfirmTransactionPage", {
        form: {
          ...this.userInfo,
          amount: this.slideThreeForm.value.depositAmt
        },
        newForm: data,
        button: "confirm & submit",
        transaction: 7
      });
    }
  }

  getAccountCount() {
    this.slideThreeForm.value.accountCount !== "0"
      ? (this.showMajorBanker = true)
      : (this.showMajorBanker = false);
  }

  debitCardRequest(event) {
    console.log(event);
    if (event.checked) {
    }
  }

  checkFocus(event) {
    this.validateAtmCost = false;
  }

  formValidations() {
    this.slideOneForm = this.formBuilder.group({
      bvn: [
        "",
        Validators.compose([
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.required
        ])
      ],
      phone: [
        "",
        Validators.compose([
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.required
        ])
      ]
    });

    this.slideTwoForm = this.formBuilder.group({
      email: [""],
      gender: ["", Validators.required],
      occupation: ["", Validators.required],
      houseNumber: ["", Validators.required],
      address: ["", Validators.required],
      city: ["", Validators.required],
      state: ["", Validators.required]
    });
    this.slideThreeForm = this.formBuilder.group({
      picture: ["", Validators.required],
      signPath: ["", Validators.required],
      accountCount: ["", Validators.required],
      majorBanker: [""],
      reason: ["", Validators.required],
      depositAmt: ["", Validators.required],
      atm: [false]
    });
  }

  private scan() {
      let imgPath, img
      const file = new File();
      const configuration = {
        source: "camera",
        jpegQuality: 20
      };
      cordova.plugins.GeniusScan.setLicenceKey(
        CONFIG.scannerKey,
        response => {
          console.log("initialized", response);
        },
        error => {
          console.log("initialized", error);
        }
      );
    return  cordova.plugins.GeniusScan.scanWithConfiguration(
        configuration,
        async result => {
          
            const [processed] = result.scans;
            const { enhancedUrl } = processed;
            const filename = enhancedUrl.substring(
              enhancedUrl.lastIndexOf("/") + 1
            );
            const path = enhancedUrl.substring(0, enhancedUrl.lastIndexOf("/") + 1);
            this.loading.presentLoading("uploading...");
            imgPath = `${path}${filename}`;
            img = await file.readAsDataURL(path, filename);
             
           // console.log(img, imgPath)
            this.loading.loader.dismiss().catch(() => {});
            return [img, imgPath]
         
        },
        error => {
          this.alert.presentNormalErrorAlert("Failed to upload, Try again");
        }
      );
    
  }

  ionViewWillLoad() {

    if (!this.navParams.data.bank.minimum_balance) { 
      this.slideThreeForm.get("depositAmt").setValue(0)
    }

    //get sites and states
    this.request.getStatesAndCities().subscribe(
      data => {
        this.states = data;
      },
      error => {
        console.log(error);
        if ((error.code === 403)) {
          this.request.logout();
        }
      }
    );

    //get bank list
    this.request.getBankList().subscribe(
      data => {
        this.banks = data;
      },
      error => {
        console.log(error);
        if (error.json().code === 403) {
          this.request.logout();
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/open-account/open-account.ts